import AOS from 'aos';
import smoothScroll from '../modules/smooth-scroll';
import parallax from '../modules/parallax';
import copyright from '../modules/copyright';

export default {
    init() {
        AOS.init();
        smoothScroll();
        parallax();
        copyright();
    },
    finalize() {},
};
